import { components } from "@/api-schema";
import { RowAction } from "@/components/ui/table-row-actions";
import { vehicleIsBlockable } from "@/common/helpers/vehicle-is-blockable";
import { LockIcon, LockOpenIcon } from "lucide-react";
import { RelocationOrderActionsContext } from "@/common/hooks/relocation-order/_helpers/relocation-order-actions-context";
import { buildManagingBranchByTransportCompanyActions } from "./relocation-order-managing-branch-by-transport-company-actions";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildOriginBranchByTransportCompanyActions(
  order: RelocationOrder,
  context: RelocationOrderActionsContext,
): RowAction[] {
  const actions: RowAction[] = [...buildManagingBranchByTransportCompanyActions(order, context)];

  const vehicle = order.vehicle;
  const vehicleIsBlocked = !!vehicle?.vehicleBlock;

  if (!vehicleIsBlocked && vehicle && vehicleIsBlockable(vehicle, order.status)) {
    actions.push({
      label: context.t("fit:BlockVehicle"),
      icon: <LockIcon className="h-4 w-4" />,
      onClick: () => context.handleBlockVehicle(vehicle),
    });
  } else if (vehicleIsBlocked && vehicle) {
    actions.push({
      label: context.t("fit:UnblockVehicle"),
      icon: <LockOpenIcon className="h-4 w-4" />,
      onClick: () => context.handleUnblockVehicle(vehicle),
    });
  }

  return actions;
}
